var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9199 2.90001H8.26986C8.15986 2.90001 8.06986 2.99001 8.06986 3.10001V16.01C7.36986 15.76 6.55986 15.72 5.74986 15.9C3.86986 16.32 2.59986 17.8 2.90986 19.21C3.21986 20.62 4.99986 21.42 6.87986 21C8.54986 20.63 9.75986 19.37 9.75986 18.01C9.75986 15.9 9.75986 9.88001 9.75986 8.69001H19.4099V16C18.7099 15.75 17.8999 15.71 17.0899 15.89C15.2099 16.31 13.9399 17.79 14.2499 19.2C14.5099 20.35 15.7499 21.1 17.2299 21.1C17.5499 21.1 17.8899 21.06 18.2199 20.99C19.8899 20.62 21.0999 19.36 21.0999 18C21.0999 14.46 21.0999 3.20001 21.0999 3.09001C21.0999 2.98001 21.0099 2.89001 20.8999 2.89001L20.9199 2.90001ZM19.4199 7.07001H9.75986V5.81001H19.4199V7.07001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.5563cad00ff7867e7ed3bfccebd7e61f.svg";
export { ForwardRef as ReactComponent };